/**
 * Data print result DTO.
 */
export class DataPrintResultDto {
	requestId!: string;
	fileUuid!: string;
	fileName!: string;
	fileMimeType!: string;
	filePayload!: Uint8Array;
}
